export default __webpack_public_path__ + "static/media/jobs-value-relentlessly-positive.263fe2b8.svg";